"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var JamoBlock_1 = require("./JamoBlock");
var isJamo_1 = __importDefault(require("./utlils/isJamo"));
var syllableToChar_1 = require("./utlils/syllableToChar");
/**
 * 한글 음절을 조합, 분해합니다.
 */
var HangulSyllable = /** @class */ (function () {
    function HangulSyllable() {
    }
    Object.defineProperty(HangulSyllable.prototype, "initialConsonat", {
        /** 초성 */
        get: function () {
            return this._initialConsonat;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HangulSyllable.prototype, "medialVowel", {
        get: function () {
            return this._medialVowel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HangulSyllable.prototype, "finalConsonat", {
        get: function () {
            return this._finalConsonat;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HangulSyllable.prototype, "composingSyllable", {
        /** 합성중인 음절 */
        get: function () {
            return syllableToChar_1.syllableToChar(this);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 글자를 입력한다.
     * @param inputChar 입력할 글자
     * @returns 더이상 입력할 수 없을 때, false를 반환
     */
    HangulSyllable.prototype.tryInput = function (inputChar) {
        if (!isJamo_1.default(inputChar))
            return false;
        var inputJamo = new JamoBlock_1.JamoBlock(inputChar);
        if (this.isEditableInitialConsonant(inputJamo)) {
            if (this._initialConsonat) {
                var block = new JamoBlock_1.JamoBlock(this._initialConsonat);
                if (block.canComposeFinalConsonants(inputChar)) {
                    this._initialConsonat = undefined;
                    this._finalConsonat = block.generateComposedCharacter(inputChar);
                    return true;
                }
                return false;
            }
            else {
                this._initialConsonat = inputChar;
                return true;
            }
        }
        if (this.isEditableMedialVowel(inputJamo)) {
            if (this._medialVowel) {
                var block = new JamoBlock_1.JamoBlock(this._medialVowel);
                if (inputJamo.isMedialVowel() && block.canComposedVowel(inputChar)) {
                    this._medialVowel = block.generateComposedCharacter(inputChar);
                    return true;
                }
            }
            else {
                this._medialVowel = inputChar;
                return true;
            }
        }
        if (this.isEditableFinalConsonant(inputJamo)) {
            if (!this._finalConsonat) {
                this._finalConsonat = inputChar;
                return true;
            }
            else {
                var block = new JamoBlock_1.JamoBlock(this._finalConsonat);
                if (this._finalConsonat && block.canComposeFinalConsonants(inputChar)) {
                    this._finalConsonat = block.generateComposedCharacter(inputChar);
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * 자모 1개를 삭제한다.
     * @returns 더이상 삭제할 수 없을 때, false를 반환다.
     */
    HangulSyllable.prototype.tryBackspace = function () {
        if (this._finalConsonat) {
            var finalConsonatBlock = new JamoBlock_1.JamoBlock(this._finalConsonat);
            var consonats = finalConsonatBlock.decompose();
            if (consonats.length >= 2) {
                consonats.pop();
                this._finalConsonat = consonats[0];
            }
            else {
                this._finalConsonat = undefined;
            }
            return true;
        }
        if (this._medialVowel) {
            var mediaVowel = new JamoBlock_1.JamoBlock(this._medialVowel);
            var vowels = mediaVowel.decompose();
            if (vowels.length >= 2) {
                vowels.pop();
                this._medialVowel = vowels[0];
            }
            else {
                this._medialVowel = undefined;
            }
            return true;
        }
        if (this._initialConsonat) {
            this._initialConsonat = undefined;
            return true;
        }
        return false;
    };
    HangulSyllable.prototype.clear = function () {
        this._initialConsonat = undefined;
        this._medialVowel = undefined;
        this._finalConsonat = undefined;
    };
    HangulSyllable.prototype.isEditableFinalConsonant = function (inputJamo) {
        return (this._initialConsonat && this._medialVowel && inputJamo.isFinalConsonant());
    };
    HangulSyllable.prototype.isEditableMedialVowel = function (inputJamo) {
        return !this._finalConsonat && inputJamo.isMedialVowel();
    };
    HangulSyllable.prototype.isEditableInitialConsonant = function (inputJamo) {
        return (!this._medialVowel && !this._finalConsonat && inputJamo.isInitialConsonant());
    };
    return HangulSyllable;
}());
exports.default = HangulSyllable;
